<section id="corr-details-container">
  <!-- Sub Header -->
  <app-header title="Select Review User">
    <!-- Filter -->
    <mat-toolbar class="filter-toolbar">
      <!--<mat-toolbar-row>-->
      <!--      <form [formGroup]="form">-->
      <!--        &lt;!&ndash; https://angular.io/docs/ts/latest/guide/template-syntax.html#!#binding-syntax &ndash;&gt;-->
      <!--        <fieldset>-->
      <!--          <div>-->
      <!--&lt;!&ndash;            <mat-form-field class="margin-right" appearance="outline">&ndash;&gt;-->
      <!--              <input-->
      <!--                matInput-->
      <!--                type="text"-->
      <!--                placeholder="Search"-->
      <!--                [formControl]="keywords" -->
      <!--              />-->
      <!--&lt;!&ndash;            </mat-form-field>&ndash;&gt;-->
      <!--&lt;!&ndash;            <mat-form-field appearance="outline">&ndash;&gt;-->
      <!--              <mat-select placeholder="Filter Role" [formControl]="userRole">-->
      <!--                @for (role of roles; track role) {-->
      <!--                  <mat-option-->
      <!--                    [value]="role.Id"-->
      <!--                    (click)="-->
      <!--                      role.Id === null ? userRole.setValue(undefined) : null-->
      <!--                    ">-->
      <!--                    {{ role.RoleName }}-->
      <!--                  </mat-option>-->
      <!--                }-->
      <!--              </mat-select>-->
      <!--&lt;!&ndash;            </mat-form-field>&ndash;&gt;-->
      <!--          </div>-->
      <!--        </fieldset>-->
      <!--      </form>-->
      <!--</mat-toolbar-row>-->
    </mat-toolbar>
  </app-header>
  <!-- User Chooser -->
  <div class="container">
    <section class="info-box">
      <h1 class="info-box-heading">Users</h1>
      <div class="info-box-wrapper">
        <div class="info-box-body">
          <mat-list class="info-box-list flex-column">
            @for (user of users; track user; let i = $index) {
            <mat-list-item>
                <h2 matListItemTitle>{{ user.LastFirst }}
                  <button mat-raised-button (click)="chooseUser(user)" style="float:right">
                    <mat-icon class="mat-icon-dark">add</mat-icon>
                  </button>

                </h2>
                <div matListItemLine>
                  <strong>Roles:</strong> {{ user.RolesSummary }}
                </div>
            </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    </section>
  </div>
</section>